import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class FileManagerService {

  constructor(private http: HttpClient, private base: BaseService) { }

  private baseUrl = this.base._baseUrl
  

  previewImage(id:number, category: string): Observable<any> {
    return this.http.get<any>(this.baseUrl +
      `/preview/photo?category=${category}&id=${id}`)
      .pipe(
        catchError(err => this.base.errorHandler(err))
      )
  }

  previewImage64(id:number, category: string): Observable<any> {
    return this.http.get<any>(this.baseUrl +
      `/preview/photograph?category=${category}&id=${id}`)
      .pipe(
        catchError(err => this.base.errorHandler(err))
      )
  }

   imageUpload(id:number, category: string, file : any):Observable<any> {
    return this.http.post<any>(this.baseUrl + 
      `/upload/photograph?category=${category}&id=${id}`,file )
    .pipe(
      catchError( err =>  this.base.errorHandler(err))
    )
  } 

 
}
